var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:health-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.5006 12.8789L25.3255 13.9769C25.4759 14.1379 25.6579 14.2663 25.86 14.3541C26.0622 14.4418 26.2802 14.4871 26.5006 14.4871C26.721 14.4871 26.939 14.4418 27.1412 14.3541C27.3433 14.2663 27.5253 14.1379 27.6757 13.9769L26.5006 12.8789ZM20.998 41.2322C17.8887 38.7104 14.2603 35.4016 11.4211 31.7797C8.54978 28.1192 6.66485 24.3601 6.66485 20.9076H3.44824C3.44824 25.4473 5.87142 29.9184 8.8886 33.7654C11.9379 37.6532 15.7721 41.1336 18.9716 43.7305L20.998 41.2322ZM6.66485 20.9076C6.66485 14.6781 9.38395 10.8289 12.7464 9.51007C16.1024 8.19555 20.7965 9.1348 25.3255 13.9769L27.6757 11.781C22.5549 6.30419 16.527 4.5758 11.5734 6.51434C6.62625 8.45288 3.44824 13.7753 3.44824 20.9076H6.66485ZM34.0274 43.7283C37.229 41.1315 41.0632 37.6511 44.1126 33.7633C47.1298 29.9162 49.5529 25.4451 49.5529 20.9033H46.3363C46.3363 24.3601 44.4493 28.1171 41.58 31.7776C38.7408 35.3995 35.1125 38.7083 32.0031 41.2301L34.0274 43.7283ZM49.5529 20.9033C49.5529 13.7731 46.3749 8.45074 41.4256 6.51434C36.4721 4.57365 30.4463 6.2999 25.3255 11.7789L27.6757 13.9769C32.2047 9.1348 36.8988 8.19341 40.2548 9.50793C43.6172 10.8246 46.3363 14.6759 46.3363 20.9033H49.5529ZM18.9716 43.7305C21.695 45.9435 23.5885 47.5668 26.5006 47.5668V44.3502C24.9502 44.3502 23.9852 43.6554 20.998 41.2322L18.9716 43.7305ZM32.0031 41.2301C29.016 43.6533 28.051 44.3502 26.5006 44.3502V47.5668C29.4127 47.5668 31.3062 45.9435 34.0296 43.7305L32.0031 41.2301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.4389 20.2256H36.1501M36.1501 20.2256H31.8613M36.1501 20.2256V15.9368M36.1501 20.2256V24.5144",
    stroke: "white",
    strokeWidth: 1.6083,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeart);
export default __webpack_public_path__ + "static/media/whiteHeart.4864d3fbf5a5ec4af692cb0f1dbedd29.svg";
export { ForwardRef as ReactComponent };